<template>
    <validation-provider
        ref="validator"
        #default="{ errors, required }"
        :name="internalLabel"
        :vid="internalVid"
        :rules="rules"
        slim
    >
        <b-form-group
            :id="fieldsetId"
            :name="internalVid"
            :description="internalDescription"
            :label="internalLabel"
            :label-for="inputId"
            :state="errors.length == 0"
        >
            <template #label>
                <slot name="label" :inputId="inputId" :label="internalLabel">
                    <label :id="fieldsetId + '__BV_label_'" :for="inputId" class="d-block" v-if="internalLabel">
                        {{ internalLabel }}
                        <span v-if="required" class="text-danger">*</span>
                    </label>
                </slot>
            </template>

            <b-input-group :prepend="countryPrefix">
                <b-form-input
                    ref="input"
                    :id="inputId"
                    :class="{'is-invalid' : errors.length > 0}"
                    :label="internalLabel"
                    v-model="internalValue"
                    @blur="handleInput()"
                    :placeholder="internalPlaceholder"
                    :data-cy="internalTestId"
                    v-bind="$attrs"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    autocomplete="off"
                    inputmode="tel"
                />
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>

    </validation-provider>
</template>

<script>

import * as _ from 'lodash-es'
import { ValidationProvider } from 'vee-validate'
import companyMixin from '@state/company'
import FormFieldBase from '../mixins/Base'

 /**
  * Componente que encapsula o b-form-input + diretiva v-mask,  para aplicar máscaras e validações baseados em tipos de telefone por país.
  * 
  * O evento change em dispositivos APPLE apresenta problemas na identificação de mudança de valores e perda de foco (blur), quando utilizado mascaras dinamicas.
  * Devido a este motivo o evento que dispara o changeable(autosave) foi alterado de change para blur, assim ao perder o foco o elemento é automaticamente salvo se for valido.
  * 
  * Se após os testes não houver novos relatos de problemas com o salvamento do telefone, substituir o componente form-field-phone por este form-field-telephone
  */
export default {
    name: 'form-field-telephone',
    mixins : [
        companyMixin,
        FormFieldBase
    ],
    components: {
        ValidationProvider
    },
    data() {
        return {
            countries: [
                {name: 'BR', code: '55'},
                {name: 'US', code: '1'},
                {name: 'ES', code: '34'},
            ]
        };
    },
    computed : {
        countryPrefix(){
            let prefix = '55'
            const found = this.countries.find(c => c.name === this.company.currentCountry)
            if(found !== null) {
                prefix = found.code
            }

            return `+${prefix}`
        }
    },
    methods: {
        handleInput() {

            // Get user input
            const value = this.internalValue || '';

            // Regex (##) ####-#### or (##) #####-####
            const regex = /^\(\d{2}\)\s?\d{4,5}-\d{4}$/;

            // Dispatch event only conditions
            if (value === '' || regex.test(value) ) {
                this.dispatchEvent('change', value);
            }
        }
    }
}
</script>
<!--
<docs>
```vue
  <template>
    <div class="container">
        <form-field-telephone v-model="cellphoneValue" name="field-name" />
        <form-field-telephone v-model="homephoneValue" name="field-name" />
    </div>
  </template>

  <script>
    export default {
      data() {
        return {
            cellphoneValue : '',
            homephoneValue : ''
        };
      }
    }
  </script>
```
</docs>
-->
